module.exports = __webpack_public_path__ + "static/img/newad2.09b56e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videoDetail/newad2.png
// module id = s0S3
// module chunks = 17